import React from 'react';

import { Box, HStack } from '@rbilabs/universal-components';
import { Typography, withTypography } from 'ucl/components/text/Typography';

import { getDesignToken } from 'styles/constants';

type TypographyProps = React.ComponentPropsWithoutRef<typeof Typography>;

export const FeeDeliveryItem = withTypography({
  color: getDesignToken('alert-warning-background'),
  bold: true,
});

export const Total = Box.withConfig({
  focusable: true,
});

export const GrandTotalLabel = withTypography({
  color: getDesignToken('text-default'),
  fontSize: 'md',
  bold: true,
  style: { flexGrow: 1 },
});

export const TotalLabel = ({
  isFreeDelivery,
  color,
  style,
  ...props
}: TypographyProps & { isFreeDelivery?: boolean; color?: string }) =>
  React.createElement(Typography, {
    color:
      color ||
      (isFreeDelivery
        ? getDesignToken('alert-warning-background')
        : getDesignToken('text-default')),
    fontSize: 'md',
    bold: !!isFreeDelivery,
    style: [{ flexGrow: 1 }, style],
    ...props,
  });

export const DonationLabel = withTypography({
  color: getDesignToken('text-default'),
});

export const TotalLabelContainer = Box.withConfig({
  flexDirection: 'row',
  alignItems: 'center',
  height: '$6',
  focusable: true,
});

export const TotalsRow = HStack;
